<template>
    <div class="topSearch">
<!--        <div class="logoImg">-->
<!--          <img src="../../assets/img/logoImg.png" alt="" :style="{height: scrollerHeight}" >-->
<!--        </div>-->
<!--   书名 下拉选择   -->
        <div class="searchSelect searchItem">
          <el-select v-model="searchForm.KeyName" placeholder="请选择">
            <el-option
              v-for="option in optionSelects"
              :key="option.index"
              :label="option.optionName"
              :value="option.index">
            </el-option>
          </el-select>
        </div>
        <div class="searchInput searchItem">
          <el-input v-model="searchForm.StrKeywords" placeholder="请输入关键词" @keydown.enter.native="getSearchBookListToBookList" type="search"></el-input>
        </div>
        <div class="searchItem">
          <el-button type="primary" size="medium" icon="el-icon-search" circle @click="getSearchBookListToBookList"></el-button>
        </div>
      </div>
</template>
<script>

export default {
  name: 'topSearch_phone',

  data () {
    return {
      optionSelects: [
        {
          index: 'all',
          optionName: '任意词'
        },
        {
          index: 'StrPositiveTitle',
          optionName: '书名'
        }, {
          index: 'StrFirstResponsible',
          optionName: '作者'
        }, {
          index: 'StrISBN',
          optionName: 'ISBN'
        }, {
          index: 'StrPublisher',
          optionName: '出版社'
        }],
      searchForm: {
        KeyName: 'all',
        StrKeywords: '',
        Sort: '-1',
        OrderBy: 'DTCreatedDate',
        OnLib: false,
        Distinct: true,
        Page: 1,
        PerPage: 10,
        StrOrganizationIDs: []
      }
    }
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    scrollerHeight: function () {
      return document.body.clientWidth > 500 ? 35 + 'px' : 17 + 'px'
    }
  },
  mounted () {
    this.searchForm.StrOrganizationIDs[0] = localStorage.getItem('library') == null ? '' : localStorage.getItem('library')
    this.searchForm.StrKeywords = sessionStorage.getItem('searchContent') == null ? '' : sessionStorage.getItem('searchContent')
    const keyname = sessionStorage.getItem('keyName')
    if (keyname !== null && keyname !== '') {
      this.searchForm.KeyName = keyname
    } else {
      this.searchForm.KeyName = 'all'
    }
  },
  methods: {
    childMethod () {
      this.$emit('fatherMethod')
    },
    getSearchBookListToBookList () {
      // 去除两端的空格，防止出现因为空格导致搜索不到的问题
      this.searchForm.StrKeywords = this.searchForm.StrKeywords.trim()
      if (this.searchForm.StrKeywords === '') {
        alert('请输入搜索词')
        return
      }
      sessionStorage.setItem('keyName', this.searchForm.KeyName)
      sessionStorage.setItem('searchContent', this.searchForm.StrKeywords)
      this.$router.push({
        path: '/bookList',
        query: { res: JSON.stringify(this.searchForm) }
      })
      this.childMethod()
    }
  }
}
</script>
<style lang="less" scoped>
.topSearch {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.searchItem{
  margin-left: 1%;
}
.searchSelect{
  width: 25%;
}
.searchInput{
  width: 60%;
}
#searchButton{
  width: 100px;
}
</style>
